import { isDevelopmentEnv, isStagingEnv } from '@mc/client-env'
import { logger } from '@mc/next-logger'

/**
 * Sets a localStorage item safely by checking availability and catching errors.
 *
 * @param {string} key - The key to set in localStorage.
 * @param {string} value - The value to store.
 */
export const safeSetLocalStorageItem = (key: string, value: string): void => {
  if (
    typeof window === 'undefined' ||
    typeof window.localStorage === 'undefined'
  ) {
    return
  }

  try {
    window.localStorage.setItem(key, value)
  } catch (err) {
    if (isDevelopmentEnv() || isStagingEnv()) {
      logger.error(`Error setting localStorage key "${key}":`, err)
    }
  }
}
